import { useEffect, useState } from "react";

import { useDataProvider } from "react-admin";

const useConditions = () => {
  const [conditions, setConditions] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  const getLTVConditionId = () => {
    const result = conditions.find(
      (cond) => cond.template.logic === "[total_ltv] >= [value]"
    );
    return result?.id;
  };

  const getPaymentConditionId = () => {
    const result = conditions.find(
      (cond) => cond.template.logic === "[paid_amount] >= [value]"
    );
    return result?.id;
  };
  useEffect(() => {
    async function fetchAll() {
      try {
        const conditions = await dataProvider.getList("conditions", {});
        setConditions(conditions.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    conditions,
    loading,
    error,
    getLTVConditionId,
    getPaymentConditionId,
  };
};

export default useConditions;
